import { render, staticRenderFns } from "./InstanceTierUpgradeBanner.vue?vue&type=template&id=12a627dd&scoped=true&"
import script from "./InstanceTierUpgradeBanner.vue?vue&type=script&lang=js&"
export * from "./InstanceTierUpgradeBanner.vue?vue&type=script&lang=js&"
import style0 from "./InstanceTierUpgradeBanner.vue?vue&type=style&index=0&id=12a627dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a627dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a627dd')) {
      api.createRecord('12a627dd', component.options)
    } else {
      api.reload('12a627dd', component.options)
    }
    module.hot.accept("./InstanceTierUpgradeBanner.vue?vue&type=template&id=12a627dd&scoped=true&", function () {
      api.rerender('12a627dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InstanceTierUpgradeBanner.vue"
export default component.exports